export default __webpack_public_path__ + "reply-arrow.png";